import { render } from "./ContextualNavigationItem.vue?vue&type=template&id=5fbc40ae&scoped=true"
import script from "./ContextualNavigationItem.vue?vue&type=script&lang=js"
export * from "./ContextualNavigationItem.vue?vue&type=script&lang=js"

import "./ContextualNavigationItem.vue?vue&type=style&index=0&id=5fbc40ae&lang=scss&scoped=true"
import "./ContextualNavigationItem.vue?vue&type=style&index=1&id=5fbc40ae&lang=scss&global=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbc40ae"]])

export default __exports__